/* eslint-disable no-useless-call */
/* eslint-disable dot-notation */
import { getUrlVariable } from './getUrlVariable'
import { horario } from './horario'
import { loadRingPool } from './loadRingPool'
import { updateGaBackEnd } from './updateGaBackEnd'
import { esSabado } from './esSabado'
import { GLOBAL_VARIABLES } from '../config'
import { getUrlVariablesObjeto } from './getUrlVariablesObjeto'
import { loadInbounds } from "./loadInbounds"

export function scriptExecute() {
  let {
    c_var_0,
    c_var_3,
    c_var_4,
    c_var_13,
    c_var_14,
    v_var_7,
    v_var_11,
    v_var_12,
    coche_var,
    sem_dis,
    servicioCampaign,
    userLabels
  } = window
  const { priorityIvr, localizacion, $, DRP, Piwik, DELIO } = window
  updateGaBackEnd()

  if (horario() === false) {
    loadRingPool()
  }

  coche_var = getUrlVariable()['coche_var']

  sem_dis = getUrlVariable()['sem_dis']
  if (coche_var !== 'undefined' && coche_var !== undefined) {
    v_var_11 = sem_dis
    window.v_var_11 = v_var_11
  } else {
    v_var_11 = ''
    window.v_var_11 = v_var_11
  }

  // RingPool
  c_var_3 = 'ringpool'
  window.c_var_3 = c_var_3
  c_var_4 = 'Coche'
  window.c_var_4 = c_var_4
  if (getUrlVariable()['dcuserid'] !== 'undefined' && getUrlVariable()['dcuserid'] !== undefined) {
    c_var_0 = getUrlVariable()['dcuserid']
    window.c_var_0 = c_var_0
  }

  // Comprobamos si la url es SEM

  let esSEM = getUrlVariable()['sem']

  if (typeof esSEM === 'undefined') {
    esSEM = 'no'
  }

  // Comprobamos si es Móvil

  const isMobile = {
    Android: function () {
      let esAndroid = navigator.userAgent.match(/Android/i)
      const ademasEsMovil = navigator.userAgent
      if (ademasEsMovil.indexOf('Mobile') === -1) {
        esAndroid = navigator.userAgent.match(/Androidffff/i)
      }

      return esAndroid
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i)
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPod/i)
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i)
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i)
    },
    any: function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
    }

  }

  const dayOfTheWeek = new Date().getDay();

  servicioCampaign = '54CCB75DC8DEE442010E600435372103'
  window.servicioCampaign = servicioCampaign
  v_var_7 = 'no'
  window.v_var_7 = v_var_7

  if (esSEM !== 'no' && isMobile.any()) {
    window.v_var_7 = 'si'
    servicioCampaign = '54CCB75DC8DEE442010E600435372103'
    window.servicioCampaign = servicioCampaign
  }

  const urlActual = window.location.origin + window.location.pathname

  if (urlActual === 'https://planesdepensiones.mapfre.es/' || urlActual === 'https://segurosdevida.mapfre.es/') {
    servicioCampaign = '3F0501CBA4596C66370F0E5919614308'
    window.servicioCampaign = servicioCampaign
  }
  if (urlActual === 'https://segurosdehogar.mapfre.es/GGCCSEN/' || urlActual === 'https://segurosdehogar.mapfre.es/GGCCJOV/') {
    servicioCampaign = dayOfTheWeek != 6 ? '8F5262A07631F55B620E600653145F00' : "AC29FDCD421C374E8811305618133806";
    window.servicioCampaign = servicioCampaign
    console.log('Servicio De Llamada Hogar: ' + 'ROPO_HOGAR_SCORING_NG_SI24= ' + window.servicioCampaign)
  }
  if (urlActual === 'https://segurosdehogar.mapfre.es/agr/') {

    servicioCampaign = dayOfTheWeek != 6 ? '8F5262A07631F55B620E600653145F00' : "54CCB75DC8DEE442010E600435372103";
    window.servicioCampaign = servicioCampaign
    console.log('Servicio De Llamada Hogar: ' + 'ROPO_HOGAR_SCORING_NG_SI24= ' + window.servicioCampaign)
  }
  if (urlActual === 'https://segurodeaccidentes.mapfre.es/GGCCSEN/') {
    servicioCampaign = '9D8AAB06A730AEADCD100B410B310204'
    window.servicioCampaign = servicioCampaign
    console.log('Servicio De Llamada Accidentes: ' + 'ROPO_ACCIDENTES_SCORING_NG_SI24=' + window.servicioCampaign)
  }
  if (urlActual === 'https://seguroparamascotas.mapfre.es/' || urlActual === 'https://seguroparamascotas.mapfre.es/GGCCJOV/' || urlActual === 'https://seguroparamascotas.mapfre.es/GGCCMAS/') {
    servicioCampaign = '528D825D382029C2740F1E4E37381C09'
    window.servicioCampaign = servicioCampaign
    console.log('Servicio De Llamada Mascotas: ' + 'ROPO_MASCOTAS_SCORING_NG_SI24=' + window.servicioCampaign)
  }

  // Priority
  userLabels = priorityIvr(window.c_var_4, localizacion.global)
  window.userLabels = userLabels

  // Add declaratives ringpool
  const date = new Date()
  const monthDate = parseInt(date.getMonth()) + 1
  const dateOpen = date.getFullYear() + '-' + monthDate + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()

  window.userLabels = window.userLabels || {}
  window.userLabels.EDeclaratives = window.userLabels.EDeclaratives || {}
  window.userLabels.EDeclaratives.fechaNavegacionUsuario = dateOpen
  window.userLabels.EDeclaratives.url_conversion_completa = window.location.href
  /* Descomentar cuando se suba lo de onetrust */
  /* window.userLabels.EDeclaratives.onetrustWS = 'landing_ringpool' */
  const allUserLabels = window.userLabels
  console.log('Consulta scriptExecute.js userLabels:', { allUserLabels })

  // Add declaratives callme
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = 'fechaNavegacionUsuario'
  input.value = dateOpen

  const wgForms = document.querySelectorAll('.wg-form')

  wgForms.forEach.call(wgForms, function (wgForm, i) {
    wgForm.appendChild(input.cloneNode(true))
  })

  document.addEventListener('DOMContentLoaded', function () {

    if (esSEM !== 'no' && isMobile.any() && esSabado()) {
      const ringPool1 = document.getElementById('ring_pool1');
      const ringPool = document.getElementById('ringPool');
      const ringPoolMob = document.getElementById('ring-pool-mob');
      const ringPool3 = document.getElementById('ringPool3');

      if (ringPool1) ringPool1.style.visibility = 'hidden';
      if (ringPool) ringPool.style.visibility = 'hidden';
      if (ringPoolMob) ringPoolMob.style.display = 'none';
      if (ringPool3) ringPool3.style.display = 'none';
    }

    const scoringPriorityValue = window.userLabels.EDeclaratives.Scoring_priority;
    const scoringIvrValue = window.userLabels.EDeclaratives.Scoring_IVR;
    const scoringPriorityExtValue = window.userLabels.EExternals[1].option;
    const scoringIvrExtValue = window.userLabels.EExternals[0].option;

    const scoringPriorityElements = [
      document.getElementById('scoring_priority'),
      document.getElementById('scoring_priority1'),
      document.getElementById('scoring_priority2')
    ];
    scoringPriorityElements.forEach(el => {
      if (el) el.value = scoringPriorityValue;
    });

    const scoringIvrElements = [
      document.getElementById('scoring_ivr'),
      document.getElementById('scoring_ivr1'),
      document.getElementById('scoring_ivr2')
    ];
    scoringIvrElements.forEach(el => {
      if (el) el.value = scoringIvrValue;
    });

    const scoringPriorityExtElements = [
      document.getElementById('scoring_priority_ext'),
      document.getElementById('scoring_priority_ext1'),
      document.getElementById('scoring_priority_ext2')
    ];
    scoringPriorityExtElements.forEach(el => {
      if (el) el.value = scoringPriorityExtValue;
    });

    const scoringIvrExtElements = [
      document.getElementById('scoring_ivr_ext'),
      document.getElementById('scoring_ivr_ext1'),
      document.getElementById('scoring_ivr_ext2')
    ];
    scoringIvrExtElements.forEach(el => {
      if (el) el.value = scoringIvrExtValue;
    });

  })

  // Priority

  document.addEventListener('DOMContentLoaded', function () {
    if (esSEM !== 'no' && isMobile.any() && esSabado()) {
      $('#ring_pool1').css('visibility', 'hidden')
      $('#ringPool').css('visibility', 'hidden')
      $('#ring-pool-mob').css('display', 'none')
      $('#ringPool3').css('display', 'none')
    }
  }, false)
  console.log('window.servicioCampaign: ' + window.servicioCampaign)
  let maskPhoneVar = '## ### ## ##'

  if (window.c_var_10 !== 'ringpool formato existente') {
    maskPhoneVar = '### ### ###'
  }

  window.DRP_ready = async function () {
    const phoneEls = document.getElementsByClassName('wm_rp_local_esp_link')
    const inboundAgr = await loadInbounds()

    const intInnitRingpool = setInterval(() => {

      if (typeof DRP != "function") return;

      try {

        DRP.init({
          defaultPhone: inboundAgr,
          capa: phoneEls,
          labels: window.userLabels,
          campaignid: window.servicioCampaign,
          maskPhone: maskPhoneVar,
          reqPhone: async function (data) {
            const inboundAgr = await loadInbounds()
            var telefonoM = data.telefono != "0" ? data.telefono : inboundAgr;

            // if (maskPhoneVar !== '### ### ###') {
            //   $('a.wm_rp_local_esp_link').attr('href', 'tel:' + telefonoM)
            //   $('a.wm_rp_local_esp_link').html(telefonoM.substring(0, 2) + ' ' + telefonoM.substring(2, 5) + ' ' + telefonoM.substring(5, 7) + ' ' + telefonoM.substring(7))
            //   // wm_rp_local_esp_linkSt
            //   $('a.wm_rp_local_esp_linkSt').html(telefonoM.substring(0, 2) + ' ' + telefonoM.substring(2, 5) + ' ' + telefonoM.substring(5, 7) + ' ' + telefonoM.substring(7))
            //   $('a.wm_rp_local_esp_linkSt').attr('href', 'tel:' + telefonoM)
            //   $('span.wm_rp_local_esp_linkSt1').html(telefonoM.substring(0, 2) + ' ' + telefonoM.substring(2, 5) + ' ' + telefonoM.substring(5, 7) + ' ' + telefonoM.substring(7))
            // } else {
            //   $('a.wm_rp_local_esp_link').attr('href', 'tel:' + telefonoM)
            //   $('a.wm_rp_local_esp_link').html(telefonoM.substring(0, 3) + ' ' + telefonoM.substring(3, 6) + ' ' + telefonoM.substring(6))
            //   // wm_rp_local_esp_linkSt
            //   $('a.wm_rp_local_esp_linkSt').html(telefonoM.substring(0, 3) + ' ' + telefonoM.substring(3, 6) + ' ' + telefonoM.substring(6))
            //   $('a.wm_rp_local_esp_linkSt').attr('href', 'tel:' + telefonoM)
            //   $('span.wm_rp_local_esp_linkSt1').html(telefonoM.substring(0, 3) + ' ' + telefonoM.substring(3, 6) + ' ' + telefonoM.substring(6))
            // }

            //-------------------------aqui
            const formatPhoneNumber = (phoneNumber, mask) => {
              if (mask === '### ### ###') {
                return phoneNumber.substring(0, 3) + ' ' + phoneNumber.substring(3, 6) + ' ' + phoneNumber.substring(6);
              } else {
                return phoneNumber.substring(0, 2) + ' ' + phoneNumber.substring(2, 5) + ' ' + phoneNumber.substring(5, 7) + ' ' + phoneNumber.substring(7);
              }
            };

            const formattedPhone = formatPhoneNumber(telefonoM, maskPhoneVar);

            const links = document.querySelectorAll('a.wm_rp_local_esp_link');
            const linksSt = document.querySelectorAll('a.wm_rp_local_esp_linkSt');
            const spansSt1 = document.querySelectorAll('span.wm_rp_local_esp_linkSt1');

            const updateElements = (elements, hrefValue, htmlContent) => {
              elements.forEach(element => {
                if (element) {
                  element.setAttribute('href', hrefValue);
                  element.innerHTML = htmlContent;
                }
              });
            };

            const updateSpanElements = (elements, htmlContent) => {
              elements.forEach(element => {
                if (element) {
                  element.innerHTML = htmlContent;
                }
              });
            };

            updateElements(links, 'tel:' + telefonoM, formattedPhone);
            updateElements(linksSt, 'tel:' + telefonoM, formattedPhone);
            updateSpanElements(spansSt1, formattedPhone);

            //-------------------------aqui

            try {
              const ringPoolTxt = document.getElementById('ringPool');
              if (ringPoolTxt) {
                ringPoolTxt.innerHTML = "<img src='./img/phoneIcon.png' class='phoneIcon'>" + ringPoolTxt.innerHTML
              }

              document.querySelector('.cc-window').style.bottom = 'auto';

            } catch (error) {

            }
          },
          called: function (data) {
            const leadId = Piwik.getAsyncTracker().getVisitorId()
            console.log('window.c_var_4= ' + window.c_var_4)
            // cargar pixel conversion
            DELIO.Async.Ajax({
              type: 'script',
              url: 'https://t.womtp.com/js/otg.min.js?idtag=55d42605642e2c273277c7d2fad0351b&orderid=' + leadId
            })
          },
          idTag: GLOBAL_VARIABLES.idTagDelioClient
        })

        clearInterval(intInnitRingpool);

      } catch (error) {
        console.error("Error -- al iniciar DRP --: ", error);
      }
    }, 1000);

  }


  const varUrl = getUrlVariablesObjeto()
  let modalidadPortal
  try {
    modalidadPortal = varUrl.ModalidadPortal
  } catch (error) { }

  if (typeof (modalidadPortal) !== 'undefined') {
    c_var_13 = varUrl.SeccionPortal
    window.c_var_13 = c_var_13
    c_var_14 = varUrl.ModalidadPortal
    window.c_var_14 = c_var_14

    if (typeof (c_var_13) !== 'undefined') {
      const input13 = document.createElement('input')
      input13.type = 'hidden'
      input13.name = 'c_var_13'// SeccionPortal
      input13.value = c_var_13
      input13.className = 'wg-cvar'

      wgForms.forEach.call(wgForms, function (wgForm, i) {
        wgForm.appendChild(input13.cloneNode(true))
      })
    }
    if (typeof (c_var_14) !== 'undefined') {
      const input14 = document.createElement('input')
      input14.type = 'hidden'
      input14.name = 'c_var_14'// ModalidadPortal
      input14.value = c_var_14
      input14.className = 'wg-cvar'

      wgForms.forEach.call(wgForms, function (wgForm, i) {
        wgForm.appendChild(input14.cloneNode(true))
      })
    }
    v_var_12 = 'Portal'
    window.v_var_12 = v_var_12

    // Ocultamos los teléfonos de ringpool si venimos de la página de mapfre
    document.getElementById('ring_pool1').style.display = 'none'
    document.getElementById('ringPool3').style.display = 'none'
    try {
      document.getElementById('ringPoolx').innerHTML = ''
      document.getElementById('ring-pool-mob').style.display = 'none'
    } catch (error) { }
  }
}
